
import { defineComponent } from 'vue';
import { useAuth } from '@/plugins/Auth';

export default defineComponent({
  name: 'Curl',
  setup() {
    const { lastCurls } = useAuth();
    return {
      lastCurls,
    };
  },
});
